const _ = require('lodash');

const getCleanedElementIds = elementIds => elementIds.map(id => _.last(('' + id).split(':')));

function getMergedDashboardFilterList(dashboardFilterList) {
  return dashboardFilterList.reduce((acc, dashboardFilter) => getMergedDashboardFilter(acc, dashboardFilter));
}
// getMergedDashboardFilter(
//   { ids: [{ level: 'campaign', value: '31233321' }], channels: ['facebook', 'google'] },
//   { status: [{ level: 'campaign', value: 'active' }], channels: ['google'] },
// );
function getMergedDashboardFilter(dashboardFilterA, dashboardFilterB) {
  const newDashboardFilter = {};
  const tDashboardFilterA = getTranslatedDashboardFilter(dashboardFilterA);
  const tDashboardFilterB = getTranslatedDashboardFilter(dashboardFilterB);
  const filterKeys = _.uniq([...Object.keys(tDashboardFilterA), ...Object.keys(tDashboardFilterB)]);
  for (const key of filterKeys) {
    newDashboardFilter[key] = [];
    const filterAValues = tDashboardFilterA[key];
    const filterBValues = tDashboardFilterB[key];
    let newValue;
    if (filterAValues && filterBValues) {
      newValue = mergeFilterValues(key, filterAValues, filterBValues);
    } else {
      newValue = filterAValues ?? filterBValues;
    }
    newDashboardFilter[key] = newValue;
  }
  return newDashboardFilter;
}

function mergeFilterValues(filterKey, filterAValues, filterBValues) {
  if (filterKey.endsWith('Ids')) {
    const elementIdsA = getCleanedElementIds(filterAValues);
    const elementIdsB = getCleanedElementIds(filterBValues);
    return _.intersection(elementIdsA, elementIdsB);
  } else if (['status'].indexOf(filterKey) > -1) {
    const valuesAByLevel = _.groupBy(filterAValues, 'level');
    const valuesBByLevel = _.groupBy(filterBValues, 'level');
    const levels = _.uniq([...Object.keys(valuesAByLevel), ...Object.keys(valuesBByLevel)]);
    const values = [];
    for (const level of levels) {
      const statusA = valuesAByLevel[level]?.map(f => f.value);
      const statusB = valuesBByLevel[level]?.map(f => f.value);
      if (statusA && statusB) {
        _.intersection(statusA, statusB).forEach(value => values.push({ level, value }));
      } else {
        values.push(...(statusA ?? statusB));
      }
    }
    return values;
  } else if (['channel', 'channels'].includes(filterKey)) {
    return _.intersection(filterAValues, filterBValues);
  } else {
    return filterAValues.concat(filterBValues);
  }
}

// not used anymore, actually the whole file should be removed once FE uses the 'where' filter format
function getMergedDashboardFilterOld(dashboardFilterA, dashboardFilterB) {
  const mergedDashboardFilter = _.mergeWith(
    {},
    getTranslatedDashboardFilter(dashboardFilterA),
    getTranslatedDashboardFilter(dashboardFilterB),
    (filterAValue, filterBValue, key) => {
      if (!filterAValue) {
        return filterBValue;
      }
      if (!filterBValue) {
        return filterAValue;
      }
      if (!filterAValue && !filterBValue) {
        return null;
      }
      if (key.endsWith('Ids')) {
        const getCleanedElementIds = elementIds => elementIds.map(id => _.last(('' + id).split(':')));
        const elementIdsA = getCleanedElementIds(filterAValue);
        const elementIdsB = getCleanedElementIds(filterBValue);
        return _.intersection(elementIdsA, elementIdsB);
      } else if (key === 'status') {
        const filterAGrouped = _.groupBy(filterAValue, 'level');
        const filterBGrouped = _.groupBy(filterBValue, 'level');
        const filterGrouped = _.mergeWith(filterAGrouped, filterBGrouped, (f1, f2) => {
          if (!f1) return f2;
          if (!f2) return f1;
          return _.intersection(f1, f2);
        });
        return Object.values(filterGrouped).flat();
      } else if (['channels'].includes(key)) {
        return _.intersection(filterAValue, filterBValue);
      } else {
        return filterAValue.concat(filterBValue);
      }
    },
  );
  return mergedDashboardFilter;
}

function getCleanedDashboardFilter(dashboardFilter) {
  if (!dashboardFilter) return null;
  return Object.entries(dashboardFilter).reduce((acc, [key, value]) => {
    if (Array.isArray(value) && value.length > 0) {
      acc[key] = value;
    }
    return acc;
  }, {});
}

function getTranslatedDashboardFilter(dashboardFilter) {
  if (!dashboardFilter) return dashboardFilter;
  const newDashboardFilter = _.cloneDeep(_.omit(dashboardFilter, ['ids', 'audiences']));
  if (dashboardFilter.ids) {
    for (const thisId of dashboardFilter.ids) {
      const { level, value } = thisId;
      if (!newDashboardFilter[level + 'Ids']) newDashboardFilter[level + 'Ids'] = [];
      newDashboardFilter[level + 'Ids'].push(value);
      newDashboardFilter[level + 'Ids'] = newDashboardFilter[level + 'Ids'].flat();
    }
  }
  if (dashboardFilter.audiences) {
    for (const thisAudience of dashboardFilter.audiences) {
      const { level, value } = thisAudience;
      if (!newDashboardFilter['_detail_' + level]) newDashboardFilter['_detail_' + level] = [];
      if (level === 'deviceTarget' && Array.isArray(value) && value.includes('OTHERS')) {
        value.splice(...[value.indexOf('OTHERS'), 1].concat(['google_undetermined', 'facebook_undetermined']));
      }
      newDashboardFilter['_detail_' + level].push(value);
      newDashboardFilter['_detail_' + level] = newDashboardFilter['_detail_' + level].flat();
    }
  }
  return newDashboardFilter;
}

module.exports = {
  getMergedDashboardFilter,
  getMergedDashboardFilterList,
  getTranslatedDashboardFilter,
  getCleanedDashboardFilter,
};

// const dashboardFilterExample = {
//   adAccountIds: [
//     'act_753852745018199',
//     'act_333591126',
//     '9372517495',
//     'act_753852745018199',
//     'act_593031651216199',
//     '1345607556',
//     '1000316225',
//     'act_333591126',
//     'act_526384411075683',
//     '18ce54x59ga',
//     'act_4831025623583732',
//     '2049242106',
//     '504460972',
//     'act_1333548606786490',
//     'act_265046130808622',
//     '18ce54rlykw',
//     '6849577590873653253',
//     'act_375158549752216',
//     '250707926_149487658',
//     'dbb6c840a1269c4eb636bf1e6',
//     '1Btk2SLyiMRNJ4BihNQOTm5xxU7-F1qrk21dSlpetrDg/0',
//   ],
//   status: [
//     {
//       level: 'campaign',
//       value: 'active',
//     },
//   ],
//   channels: ['facebook', 'google'],
//   titles: [
//     {
//       level: 'campaign',
//       value: 'test',
//     },
//   ],
//   campaignIds: ['423432'],
// };
